<template>
<div>
    <base-header v-once pageName="나의고객보기 - 가구화정보" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="familyInfo">
            <p>가구화 정보가 총 <em>{{familyCount}}</em>건이 조회됩니다.</p>
            <ul>
                <li v-for="(family, index) in custFamilyList" :key="index" ><strong>{{family.chlnNm}}</strong> <span v-if="family.age != null">{{family.age}}세</span></li>
            </ul>
        </div>
    </section> 
</div>
</template>

<script>
export default {
  data() {
      return{
          kwkkey: "",
          custDiv: "",
          custFamilyList: [],
          familyCount: 0
      };
  },
  methods: {
    detailView: function(index){
        if(this.custDiv == 'SCD01'){ // 계약고객인 경우
            var selectedChlnKwkey = this.custFamilyList[index].chlnKwkey; //고객 구분키(가망:CUSTSRNO, 계약:KWKKEY)
            
            var child = {
                name: "family-pop-selected-chlnkwkey",
                data: {
                        selectedChlnKwkey:selectedChlnKwkey,
                    }
            };
            console.log("FamilyInfo.vue detailView child",child);
            this.$utils.nativeIf.outbound.sendChildData(child);
        }
    },
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
        if(parent.name == 'family-pop-param'){  // 부모창에서 받은 정보.
            console.log("FamilyInfo.vue mounted this.$store.getters.parent.data", parent.data);
            this.kwkkey = parent.data.kwkkey;
            this.custDiv = parent.data.custDiv;

        var that = this;
        var params = {kwkkey:this.kwkkey,custDiv:this.custDiv};

        this.$api.myCstmr.getCustFamilyList(params)
            .then(function(res) {
                that.custFamilyList = res;
                that.familyCount = that.custFamilyList.length;
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });

        }
  }
};
</script>
